import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { DateTimePickerAdapter } from 'components/enhanced/form/adapters/date-time/DateTimePickerAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';

interface HistoryDateTimeUpdateDialogProps {
  id: number;
  handleUpdate?: (id: number, datetime: string) => void;
}

export const HistoryDateTimeUpdateDialog = ({
  id,
  handleUpdate
}: HistoryDateTimeUpdateDialogProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (values: { datetime: string }) => {
    handleUpdate?.(id, values.datetime);
    handleClose();
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          handleOpen();
        }}>
        <EditCalendarIcon fontSize="small" color="action" /> {t('actions.update')}
      </IconButton>
      <EnhancedDialog
        open={open}
        onClose={handleClose}
        title={t('global.history-update-title')}
        subTitle={t('global.history-update-message')}
        submitLabel={t('actions.confirm')}
        cancelLabel={t('actions.cancel')}
        disableAutoFocus
        submitButtonProps={{
          type: 'submit',
          form: 'updateHistoryLine'
        }}>
        <EnhancedForm onSubmit={handleSubmit} formId="updateHistoryLine" hideControls>
          <IdentityField
            name="datetime"
            component={DateTimePickerAdapter}
            label={t('global.datetime')}
            type="text"
          />
        </EnhancedForm>
      </EnhancedDialog>
    </>
  );
};

export default HistoryDateTimeUpdateDialog;
